module.exports = __webpack_public_path__ + "media/images/chevron-right-52267ebb00c6185b1d4f3567dc71990f.svg";